import styled, { keyframes } from 'styled-components';
import colors from 'styles/colors';

/** Drawer lateral "Personalizar match de licitações" (Figma 4:4505). */

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(33, 53, 74, 0.35);
  z-index: 1050;
  display: flex;
  justify-content: flex-end;
`;

export const Panel = styled.div`
  width: 560px;
  max-width: 94vw;
  height: 100%;
  background: ${colors.$gray100};
  display: flex;
  flex-direction: column;
  animation: ${slideIn} 0.2s ease;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: ${colors.$white};
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.25));

    .title {
      display: flex;
      align-items: center;
      gap: 8px;
      color: ${colors.$dark};
      font-size: 18px;
      font-weight: 600;
    }

    .title img {
      display: block;
      width: 26px;
      height: 24px;
    }

    .close {
      display: flex;
      align-items: center;
      padding: 0;
      border: none;
      background: none;
      color: ${colors.$gray700};
      cursor: pointer;
    }

    .close .material-icons {
      font-size: 20px;
    }
  }

  .abas {
    display: flex;
    gap: 4px;
    padding: 0 16px;
    background: ${colors.$white};
    border-bottom: 1px solid ${colors.$gray500};
  }

  .aba {
    padding: 10px 12px;
    border: none;
    border-bottom: 2px solid transparent;
    background: none;
    color: ${colors.$gray700};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }

  .aba--ativa {
    border-bottom-color: ${colors.$primary};
    color: ${colors.$primary};
  }

  .content {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
  }

  .field-title {
    margin: 0;
    color: ${colors.$black};
    font-size: 16px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.32px;
  }

  .field-hint {
    margin: 4px 0 0;
    color: ${colors.$black};
    font-size: 14px;
    line-height: 1.2;
    letter-spacing: -0.28px;
  }

  .dictate-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    min-height: 32px;
    margin: 4px 0;
  }

  .dictate-wave {
    flex: 1;
    overflow: hidden;
  }

  .dictate {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0;
    border: none;
    background: none;
    color: ${colors.$primary};
    font-size: 14px;
    cursor: pointer;

    .material-icons {
      font-size: 20px;
    }
  }

  .dictate-controls {
    display: flex;
    align-items: center;
    gap: 8px;

    button {
      display: inline-flex;
      align-items: center;
      padding: 0;
      border: none;
      background: none;
      cursor: pointer;

      &:disabled {
        cursor: default;
      }
    }

    .material-icons {
      font-size: 20px;
    }

    .dictate-cancel {
      color: ${colors.$danger};
    }

    .dictate-confirm {
      color: ${colors.$primary};
    }

    .dictate-transcribing {
      color: ${colors.$gray600};
      font-size: 13px;
    }
  }

  textarea {
    width: 100%;
    height: 185px;
    resize: vertical;
    padding: 8px 10px;
    background: ${colors.$white};
    border: 1px solid #dfdfdf;
    border-radius: 4px;
    color: ${colors.$gray900};
    font-size: 14px;
    line-height: 18px;
    outline: none;

    &::placeholder {
      color: #808080;
    }

    &:focus {
      border-color: ${colors.$primary};
    }
  }

  .alert-saved {
    padding: 16px;
    background: ${colors.$success_light_bg};
    border: 1px solid ${colors.$success_light_bg_hover};
    border-radius: 4px;
    color: #155724;
    font-size: 14px;
    line-height: 18px;
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .history-toggle {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0;
    border: none;
    background: none;
    color: ${colors.$primary};
    font-size: 14px;
    cursor: pointer;

    .material-icons {
      font-size: 16px;
    }
  }

  .save {
    height: 35px;
    padding: 8px 16px;
    background: ${colors.$primary};
    border: 1px solid ${colors.$primary};
    border-radius: 4px;
    color: ${colors.$white};
    font-size: 16px;
    line-height: 1.2;
    letter-spacing: -0.32px;
    cursor: pointer;

    &:disabled {
      opacity: 0.65;
      cursor: default;
    }
  }

  .history {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 16px;
    border: 1px solid ${colors.$gray500};
    border-radius: 4px;

    .history-day {
      color: ${colors.$gray900};
      font-size: 14px;
    }

    .history-item {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 16px;
      border-radius: 4px;
      font-size: 14px;

      &.current {
        background: ${colors.$white};
        border: 1px solid ${colors.$gray400};
      }
    }

    .history-item-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: ${colors.$gray900};

      b {
        font-weight: 700;
      }
    }

    .history-item-text {
      margin: 0;
      color: ${colors.$gray700};
    }

    .history-empty {
      margin: 0;
      color: ${colors.$gray600};
      font-size: 14px;
    }
  }
`;
